import { render, staticRenderFns } from "./StandardPreview.vue?vue&type=template&id=070d4fbe&"
import script from "./StandardPreview.vue?vue&type=script&lang=js&"
export * from "./StandardPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports